<div class="forgot-email-container">
  <div class="forgot-email-box">
   <div class="logo-header">
    <img [src]="logoPath" alt="Nevada Department of Education Logo" class="nde-logo">
   </div>
  
  <hr class="horizontal-line" />
  
  <div class="content">
    <div class="heading-content">
      <h2 class="title">Recover Your Email Address</h2>
    <p class="subtitle ">Select a method to receive a one-time verification code and verify your identity.</p>
    </div>
    
    <form [formGroup]="recoveryForm" (ngSubmit)="onSubmit()">
      <div class="method-options">
        <label class="option" [ngClass]="{'selected': recoveryForm.get('method').value === 'email'}">
          <input type="radio" formControlName="method" value="email" />
          <div class="radio-button">
            <div class="radio-inner"></div>
          </div>
          <span class="option-label">Recovery Email</span>
        </label>
        <label class="option" [ngClass]="{'selected': recoveryForm.get('method').value === 'phone'}">
          <input type="radio" formControlName="method" value="phone" />
          <div class="radio-button">
            <div class="radio-inner"></div>
          </div>
          <span class="option-label">Phone Number</span>
        </label>
      </div>
      
      <div class="text-field">
        <div class="label-container">
          <label *ngIf="recoveryForm.get('method').value === 'email'" for="recoveryEmail" class="input-label">Enter Recovery Email<span class="required">*</span></label>
          <label *ngIf="recoveryForm.get('method').value === 'phone'" for="phoneNumber" class="input-label">Enter Phone Number<span class="required">*</span></label>
        </div>
        <div class="input-container">
          <input *ngIf="recoveryForm.get('method').value === 'email'" 
                id="recoveryEmail" 
                type="email" 
                formControlName="recoveryEmail" 
                class="input-field" 
                placeholder="" 
                autocomplete="email" />
          <input *ngIf="recoveryForm.get('method').value === 'phone'" 
                id="phoneNumber" 
                type="tel" 
                formControlName="phoneNumber" 
                class="input-field" 
                placeholder="(555) 555-5555" 
                autocomplete="tel" />
        </div>
        <!-- Email validation messages -->
        <div *ngIf="(recoveryForm.get('recoveryEmail')?.invalid || recoveryForm.get('recoveryEmail')?.value && !isValidEmail(recoveryForm.get('recoveryEmail')?.value)) && (recoveryForm.get('recoveryEmail')?.touched || recoveryForm.get('recoveryEmail')?.dirty) && recoveryForm.get('method').value === 'email'" class="helper-text" style="color: rgb(255, 0, 0);">
          <ng-container *ngIf="recoveryForm.get('recoveryEmail')?.errors?.['required']">
            Please enter the email address.
          </ng-container>
          <ng-container *ngIf="(recoveryForm.get('recoveryEmail')?.errors?.['email'] && !recoveryForm.get('recoveryEmail')?.errors?.['required']) || (recoveryForm.get('recoveryEmail')?.value && !isValidEmail(recoveryForm.get('recoveryEmail')?.value))">
            Please enter a valid email address.
          </ng-container>
        </div>
        
        <div *ngIf="recoveryForm.get('phoneNumber')?.invalid && recoveryForm.get('phoneNumber')?.touched && recoveryForm.get('method').value === 'phone'" class="helper-text" style="color: rgb(255, 0, 0);">
          <ng-container *ngIf="recoveryForm.get('phoneNumber')?.errors?.['required']">
            Please enter the phone number.
          </ng-container>
          <ng-container *ngIf="recoveryForm.get('phoneNumber')?.errors?.['pattern'] && !recoveryForm.get('phoneNumber')?.errors?.['required']">
            Please enter a valid US or Canada phone number.
          </ng-container>
        </div>
      </div>
      
      <button type="submit" class="submit-btn" [disabled]="recoveryForm.invalid || isSubmitting">
        <span>Send Verification Code</span>
      </button>
    </form>
  </div>
  </div>
</div>